// @ts-check

if (!customElements.get("ff-search-drawer")) {
  class FfSearchDrawer extends FfDrawer {
    constructor() {
      super();
      
      /**
       * @type {HTMLInputElement}
       */
      // @ts-ignore
      const searchInput = document.querySelector("[data-ff-search-input]");

      /**
       * @type {HTMLButtonElement}
       */
      // @ts-ignore
      const inputButton = document.querySelector("[data-ff-search-submit]");

      /**
       * @type {HTMLFormElement}
       */
      // @ts-ignore
      const searchForm = this.querySelector("form");

      searchForm.addEventListener("submit", async (e) => {
        e.preventDefault();

        const searchUrl = new URL(searchForm.action);
        searchUrl.search = "";

        new URL(window.location.href).searchParams.forEach((value, key) => {
          searchUrl.searchParams.append(key, value);
        });
        searchUrl.searchParams.set("q", searchInput.value);

        location.href = searchUrl.href;
      });

      if (searchInput.value.length > 0) {
        inputButton.classList.remove("ff-d-none");
      } else {
        inputButton.classList.add("ff-d-none");
      }

      searchInput.addEventListener("input", (e) => {
        if (e.currentTarget.value.length > 0) {
          inputButton.classList.remove("ff-d-none");
        } else {
          inputButton.classList.add("ff-d-none");
        }
      });
    }
  }

  customElements.define("ff-search-drawer", FfSearchDrawer);
}
